<!--企业简介-董事长简介-->
<template>
  <div class="chairman-profile-wrap">
    <!-- 顶部导航占位 -->
    <div class="pc-navbar"></div>

    <!-- 标题区域 -->
    <div class="title-section">
      <span>董事</span>长简介
    </div>

    <!-- 简介内容区域（加载骨架屏） -->
    <el-skeleton v-if="loading" :loading="loading" row="5" animated />
    <div v-else class="desc-section">
      <!-- 富文本内容 -->
      <div class="desc-left" v-html="richTextContent"></div>
      <!-- 头像 -->
      <div class="desc-right">
        <img
            :src="topImgSrc"
            alt="董事长头像"
            class="avatar-img"
            loading="lazy"
        />
      </div>
    </div>

    <!-- 相关新闻列表 -->
    <!--    <div class="news-section" v-if="newsList.length">-->
    <!--      <el-row class="news-row"> &lt;!&ndash; gutter增加列间距 &ndash;&gt;-->
    <!--        <el-col-->
    <!--            :span="12"-->
    <!--            :xs="24"-->
    <!--            :sm="12"-->
    <!--            v-for="(news, index) in newsList"-->
    <!--            :key="index"-->
    <!--            class="news-col"-->
    <!--            @click.native="handleNewsClickCore(news)"-->
    <!--        >-->
    <!--        <div class="news-card">-->
    <!--          <img-->
    <!--              :src="news.thumbnail"-->
    <!--              alt="新闻图片"-->
    <!--              class="news-img"-->
    <!--              loading="lazy"-->
    <!--          />-->
    <!--          <p class="news-title">{{ news.name || "暂无标题" }}</p>-->
    <!--        </div>-->
    <!--        </el-col>-->
    <!--      </el-row>-->
    <!--    </div>-->
    <!--    &lt;!&ndash; 无新闻提示 &ndash;&gt;-->
    <!--    <div class="empty-tip" v-else>暂无相关新闻</div>-->
  </div>
</template>

<script>
import { getGroupInfo } from "@/api/home";

export default {
  name: "ChairmansProfile",
  data() {
    return {
      loading: false,
      richTextContent: "", // 过滤后的富文本内容
      topImgSrc: "", // 董事长头像
      newsList: [], // 相关新闻列表
      // 常量配置（便于统一维护）
      CONST: {
        API_TYPE: "chairman_profile",
        ERROR_MSG: {
          NETWORK: "网络异常，请稍后重试",
          DATA_EMPTY: "暂无董事长简介数据"
        },
      }
    };
  },
  created() {
    this.fetchChairmanProfile();
  },
  methods: {
    /**
     * 获取董事长简介数据
     */
    async fetchChairmanProfile() {
      try {
        this.loading = true;
        const res = await getGroupInfo(this.CONST.API_TYPE);

        // 接口返回成功且有数据
        if (res.code === 200 && Array.isArray(res.data) && res.data.length) {
          const profileData = res.data[0];
          this.richTextContent = profileData.richText || "";
          // 2. 头像赋值
          this.topImgSrc = profileData.thumbnail;
          // 3. 相关新闻列表
          this.newsList = Array.isArray(profileData.children) ? profileData.children : [];
        } else {
          // 无数据兜底提示
          this.$message.warning(this.CONST.ERROR_MSG.DATA_EMPTY);
          this.resetData(); // 重置数据
        }
      } catch (error) {
        this.$message.error(this.CONST.ERROR_MSG.NETWORK);
        this.resetData(); // 重置数据
      } finally {
        this.loading = false;
      }
    },
    /**
     * 重置数据（统一兜底逻辑）
     */
    resetData() {
      this.richTextContent = "";
      this.topImgSrc = "";
      this.newsList = [];
    },

    // 新闻点击核心逻辑
    handleNewsClickCore(targetItem) {
      console.log("handleNewsClickCore", targetItem);

      const { url, urlType } = targetItem;

      try {
        // 1. 外部链接（urlType=1）
        if (urlType === '1') {
          if (!url || !/^https?:\/\//.test(url)) {
            this.$message.warning("外部链接格式错误，请检查");
            return;
          }
          window.open(url, '_blank', 'noopener,noreferrer');
        }
        // 2. 内部路由（urlType=2）
        else if (urlType === '2') {
          if (!url && !targetItem.id) {
            this.$message.warning("缺少跳转参数");
            return;
          }
          this.$router.push({
            path: '/newsDetail',
            query: {
              newsId: targetItem.id,
              type: this.CONST.API_TYPE
            }
          });
        }
        // 3. 无跳转类型
        else {
          this.$message.info("该新闻暂无跳转链接");
        }
      } catch (error) {
        console.error("新闻跳转失败：", error);
        this.$message.error("跳转失败，请稍后重试");
      }
    },
  }
};
</script>

<style scoped lang="scss">
// 定义CSS变量，便于统一维护
$font-main-color: #020202;
$bg-light: #ececec;
$bg-desc: #dce3ed;
$border-radius: 20px;
$font-base-size: 16px;

.chairman-profile-wrap {
  width: 100%;
  color: $font-main-color;
  font-size: $font-base-size;

  // 顶部导航
  .pc-navbar {
    height: 90px;
    height: clamp(60px, 8vw, 90px); // 响应式高度
    background: $bg-light;
  }

  // 标题区域
  .title-section {
    font-size: clamp(30px, 5vw, 60px); // 响应式字体
    padding: clamp(40px, 6vw, 70px) 6% clamp(10px, 2vw, 20px);
    font-weight: bold;
    letter-spacing: 5px;

    span {
      border-bottom: 5px solid $font-main-color;
    }
  }

  // 简介内容区域
  .desc-section {
    background: $bg-desc;
    padding: 4% 6%;
    display: flex;
    flex-wrap: wrap; // 移动端自动换行
    gap: 20px; // 列间距
    align-items: stretch; // 关键修改：让子元素高度拉伸至容器高度一致

    .desc-left {
      width: 100%;
      flex: 1 1 700px; // 弹性布局，最小宽度700px
      font-size: clamp(16px, 1.8vw, 20px);
      text-align: justify;
      letter-spacing: 3px;
      line-height: 1.8;

      .man_desc_title {
        font-size: clamp(20px, 2.5vw, 30px);
        font-weight: bold;
        padding-bottom: clamp(30px, 4vw, 50px);
      }

      p {
        padding-top: clamp(20px, 3vw, 40px);
      }
    }

    .desc-right {
      width: 100%;
      flex: 0 0 auto; // 关键修改：取消弹性增长，固定宽度
      max-width: 300px; // 关键修改：限制最大宽度，让图片更小
      display: flex; // 关键修改：flex布局让图片垂直居中
      align-items: center; // 垂直居中
      justify-content: center; // 水平居中
      height: 100%; // 关键修改：高度100%，和文字区域对齐

      .avatar-img {
        max-width: 100%; // 防止图片溢出
        max-height: 100%; // 关键修改：最大高度100%，和容器高度一致
        width: auto; // 关键修改：宽度自适应
        height: auto; // 保持宽高比
        object-fit: contain; // 关键修改：保持图片完整显示，不拉伸
      }
    }
  }

  // 相关新闻区域
  .news-section {
    padding-top: clamp(60px, 8vw, 100px);
    width: 88%;
    margin: 0 auto;
    text-align: center;

    .news-row {
      padding-top: clamp(20px, 2.5vw, 30px);
    }

    .news-col {
      margin-bottom: 30px; // 增加列间距
      cursor: pointer;
    }

    .news-card {
      margin: 0 auto;
      width: 90%; // 放宽宽度，适配移动端
      text-align: center;

      .news-img {
        width: 100%; // 宽度自适应
        height: auto;
        border-radius: $border-radius;
      }

      .news-title {
        font-size: clamp(16px, 1.8vw, 20px);
        font-weight: bold;
        padding: 10px;
        word-break: break-all; // 超长标题换行
      }
    }
  }

  // 无数据提示
  .empty-tip {
    padding: 50px 0;
    text-align: center;
    font-size: 18px;
    color: #999;
  }
}

// 富文本样式穿透（解决scoped不生效问题）
::v-deep .desc-left p {
  margin: 0;
}
::v-deep .desc-left h1,
::v-deep .desc-left h2,
::v-deep .desc-left h3 {
  margin: 20px 0;
  font-weight: bold;
}
</style>